import { Link, useNavigate, useParams, useLoaderData } from "react-router-dom";
import { useState } from "react";

import { DatconsumoUpdate } from "./DatconsumoUpdate";
import { DatconsumoDelete } from "./DatconsumoDelete";

export function DatconsumoEdit(props) {
  const datconsumo = useLoaderData();
  const navigate = useNavigate();
  const errorMessage = datconsumo.message;

  const [isCreatingButton, setIsCreatingButton] = useState(false);
  const [isDeletingButton, setIsDeletingButton] = useState(false);

  const [datconsResp, setDatconsResp] = useState(datconsumo.meta?.datconsResp);
  const [datconsFecha, setDatconsFecha] = useState(datconsumo.meta?.metaFecha);
  const [datconsTipo, setDatconsTipo] = useState(
    datconsumo.meta?.datconsTipo || "Ingreso"
  );

  const [datconsSustRep, setDatconsSustRep] = useState(
    datconsumo.meta?.datconsSustRep
  );

  const [datconsObs, setDatconsObs] = useState(datconsumo.meta?.datconsObs);
  let { tratamientoId } = useParams();
  let { pacienteId } = useParams();
  let datconsumoId = datconsumo.id;

  const handleDatconsSustRepChange = (event, index) => {
    let data = [...datconsSustRep];
    data[index][event.target.name] = event.target.value;
    setDatconsSustRep(data);
  };

  const addDatconsSustRep = (e) => {
    e.preventDefault();
    let object = {
      sustancia: "",
      canthabitual: "",
      unidad: "",
      distribucion: "",
      frechabitual: "",
      viaadministracion: "",
      edadinicial: "",
      edadabuso: "",
      mesesconsumact: "",
      nivelimportancia: "",
    };

    setDatconsSustRep([...datconsSustRep, object]);
  };

  const removeFields = (event, index) => {
    event.preventDefault();
    let data = [...datconsSustRep];
    data.splice(index, 1);
    console.log(data);
    setDatconsSustRep(data);
  };

  const datconsDate = new Date(datconsumo.date);
  const diffDate = Math.abs(new Date() - datconsDate) / 36e5;


  const submitDatconsumo = async (e) => {
    e.preventDefault();
    setIsCreatingButton(true);
    try {
      await DatconsumoUpdate(
        datconsResp,
        datconsFecha,
        datconsTipo,
        datconsSustRep,
        datconsObs,
        tratamientoId,
        pacienteId,
        datconsumoId
      ).then(
        (val) => {
          navigate(
            `../${tratamientoId}/antecedentes/datos-consumo/${datconsumoId}`
          );
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  const deleteItem = async (e) => {
    e.preventDefault();
    setIsDeletingButton(true);
    try {
      await DatconsumoDelete(datconsumoId).then(
        (val) => {
          window.location.replace("../");
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <div id="content">
        {datconsumo.length === 0 ? (
          <div>Cargando...</div>
        ) : errorMessage ? (
          <p>{errorMessage}</p>
        ) : (
          <form id="formUpdatelement" onSubmit={submitDatconsumo}>
            <fieldset id="disabledContainer">
              <div className="grid--2col">
                <div className="field">
                  <label htmlFor="datconsResp">Responsable</label>
                  <div className="control">
                    <input
                      className="input"
                      id="datconsResp"
                      // required
                      type="text"
                      value={datconsResp}
                      onChange={(e) => setDatconsResp(e.target.value)}
                    />
                  </div>
                </div>
                <div className="field">
                  <label htmlFor="datconsFecha">Fecha visita</label>
                  <div className="control">
                    <input
                      className="input"
                      id="datconsFecha"
                      required
                      type="date"
                      value={datconsFecha}
                      onChange={(e) => setDatconsFecha(e.target.value)}
                    />
                  </div>
                </div>
                <div className="field">
                  <label htmlFor="datconsTipo">Tipo</label>
                  <div className="control">
                    <div className="select">
                      <select
                        className="select"
                        id="datconsTipo"
                        required
                        name="datconsTipo"
                        value={datconsTipo}
                        onChange={(e) => setDatconsTipo(e.target.value)}
                      >
                        <option disabled value="">
                          {" "}
                          -- Selecciona una opción --
                        </option>
                        <option value="Valoración">Valoración</option>
                        <option value="Ingreso">Ingreso</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <h3>Sustancias Actuales</h3>
              <div className="datconsSustRepContainer">
                {/* aqui empieza el campo repetido */}

                {datconsSustRep.map((form, index) => {
                  return (
                    <div className="datconsSustRepItem" key={index}>
                      <div className="grid--10col">
                        <div className="field">
                          <label htmlFor="sustancia">Sustancia</label>
                          <div className="control">
                            <div className="select">
                              <select
                                className="select"
                                name="sustancia"
                                value={form.sustancia}
                                onChange={(event) =>
                                  handleDatconsSustRepChange(event, index)
                                }
                              >
                                <option disabled value="">
                                  -- Selecciona una opción --
                                </option>
                                <optgroup label="Alcohol">
                                  <option value="aguardiente">Aguardiente</option>
                                  <option value="alcohol">Alcohol</option>
                                  <option value="anis">Anís</option>
                                  <option value="cerveza">Cerveza</option>
                                  <option value="champan">Champán</option>
                                  <option value="conac">Coñac</option>
                                  <option value="ginebra">Ginebra</option>
                                  <option value="licor">Licor</option>
                                  <option value="ron">Ron</option>
                                  <option value="tequila">Tequila</option>
                                  <option value="vermut">Vermut</option>
                                  <option value="vino">Vino</option>
                                  <option value="vodka">Vodka</option>
                                  <option value="whisky">Whisky</option>
                                </optgroup>
                                <optgroup label="Fármacos">
                                  <option value="agomelatina">Agomelatina (Valdoxan)</option>
                                  <option value="alprazolam">Alprazolam (Trankimazin)</option>
                                  <option value="amisulprida">Amisulprida (Solian)</option>
                                  <option value="amitriptilina">Amitriptilina (Tryptizol)</option>
                                  <option value="analgesico">Analgésico</option>
                                  <option value="anticonvulsivo">Anticonvulsivo</option>
                                  <option value="antidepresivo">Antidepresivo</option>
                                  <option value="antihistaminico">Antihistamínico</option>
                                  <option value="antipsicotico">Antipsicótico</option>
                                  <option value="aripiprazol">Aripiprazol (Abilify)</option>
                                  <option value="benzodiacepina">Benzodiazepina</option>
                                  <option value="brexpiprazol">Brexpiprazol (Rxulti)</option>
                                  <option value="bromazepam">Bromazepam (Lexatin)</option>
                                  <option value="bupropion">Bupropion (Elontril)</option>
                                  <option value="cariprazina">Cariprazina (Reagila)</option>
                                  <option value="citalopram">Citalopram (Prisdal)</option>
                                  <option value="clomipramina">Clomipramina (Anafranil)</option>
                                  <option value="clordiacepoxido">Clordiacepóxido (Librium)</option>
                                  <option value="clonacepam">Clonacepam (Rivotril)</option>
                                  <option value="cloracepato">Cloracepato (Tranxilium)</option>
                                  <option value="clorpromazina">Clorpromazina (Largactil)</option>
                                  <option value="clozapina">Clozapina (Leponex)</option>
                                  <option value="diazepam">Diazepam (Valium)</option>
                                  <option value="desvenlafaxina">Desvenlafaxina (Pristiq)</option>
                                  <option value="duloxetina">Duloxetina (Cymbalta)</option>
                                  <option value="escitalopram">Escitalopram (Cipralex, Esertia)</option>
                                  <option value="flufenazina">Flufenazina (Moditen)</option>
                                  <option value="flunitracepam">Flunitracepam (Rohypnol)</option>
                                  <option value="fluoxetina">Fluoxetina (Prozac)</option>
                                  <option value="flurazepam">Flurazepam (Dormodor)</option>
                                  <option value="fluvoxamina">Fluvoxamina (Dumirox)</option>
                                  <option value="haloperidol">Haloperidol</option>
                                  <option value="hipnotico">Hipnótico</option>
                                  <option value="imipramina">Imipramina (Tofranil)</option>
                                  <option value="ketazolam">Ketazolam (Sedotime)</option>
                                  <option value="levomepromazina">Levomepromazina (Sinogan)</option>
                                  <option value="lorazepam">Lorazepam (Orfidal)</option>
                                  <option value="lormetazepam">Lormetazepam (Noctamid)</option>
                                  <option value="metilfenidato">Metilfenidato (Concerta)</option>
                                  <option value="midazolam">Midazolam (Dormicum)</option>
                                  <option value="mirtazapina">Mirtazapina (Rexer, Vastat)</option>
                                  <option value="olanzapina">Olanzapina (Zyprexa)</option>
                                  <option value="oxazepam">Oxazepam</option>
                                  <option value="paliperidona">Paliperidona (Invega)</option>
                                  <option value="paroxetina">Paroxetina (Seroxat)</option>
                                  <option value="quetiapina">Quetiapina (Seroquel)</option>
                                  <option value="risperidona">Risperidona (Risperdal)</option>
                                  <option value="sertralina">Sertralina (Besitran, Aremis)</option>
                                  <option value="trazodona">Trazodona (Deprax)</option>
                                  <option value="venlafaxina">Venlafaxina (Dobupal, Vandral)</option>
                                  <option value="vortioxetina">Vortioxetina (Brintellix)</option>
                                  <option value="zolpidem">Zolpidem (Stilnox)</option>
                                  <option value="zopiclona">Zopiclona (Limovan)</option>
                                  <option value="ziprasidona">Ziprasidona (Zeldox)</option>
                                  <option value="zuclopentixol">Zuclopentixol (Clopixol)</option>
                                </optgroup>
                                <optgroup label="Sustancias">
                                  <option value="anfetaminas">
                                    Anfetaminas
                                  </option>
                                  <option value="buprenorfina">
                                    Buprenorfina
                                  </option>
                                  <option value="cannabis">Cannabis</option>
                                  <option value="cocaina">Cocaína</option>
                                  <option value="codeina">Codeína</option>
                                  <option value="fentalino">Fentalino</option>
                                  <option value="ghb">GHB</option>
                                  <option value="heroina">Heroína</option>
                                  <option value="ketamina">Ketamina</option>
                                  <option value="mefedrona">Mefedrona</option>
                                  <option value="metadona">Metadona</option>
                                  <option value="metanfetamina">
                                    Metanfetamina
                                  </option>
                                  <option value="morfina">Morfina</option>
                                  <option value="oxicodona">Oxicodona</option>
                                  <option value="tramadol">Tramadol</option>
                                </optgroup>
                                {/* Opción adicional para mostrar el valor si no coincide con ninguna opción */}
                                {form.sustancia && (
                                  <option value={form.sustancia}>
                                    {form.sustancia}
                                  </option>
                                )}
                              </select>
                            </div>
                          </div>
                        </div>

                        <div className="field">
                          <label htmlFor="canthabitual">
                            Cantidad habitual
                          </label>
                          <div className="control">
                            <input
                              className="input"
                              name="canthabitual"
                              type="text"
                              value={form.canthabitual}
                              onChange={(event) =>
                                handleDatconsSustRepChange(event, index)
                              }
                            />
                          </div>
                        </div>
                        <div className="field">
                          <label htmlFor="unidad">Unidad</label>
                          <div className="control">
                            <div className="select">
                              <select
                                className="select"
                                name="unidad"
                                value={form.unidad}
                                onChange={(event) =>
                                  handleDatconsSustRepChange(event, index)
                                }
                              >
                                <option disabled value="">
                                  -- Selecciona una opción --
                                </option>
                                <option value="miligramo">mgr.</option>
                                <option value="gramo">gr.</option>
                                <option value="mililitro">ml.</option>
                                <option value="centilitro">cl.</option>
                                <option value="litro">l.</option>
                                <option value="unidades">unidades</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="field">
                          <label htmlFor="distribucion">Distribución</label>
                          <div className="control">
                            <div className="select">
                              <select
                                className="select"
                                name="distribucion"
                                value={form.distribucion}
                                onChange={(event) =>
                                  handleDatconsSustRepChange(event, index)
                                }
                              >
                                <option disabled value="">
                                  -- Selecciona una opción --
                                </option>
                                <option value="hospitalaria">
                                  durante el dia
                                </option>
                                <option value="manmednoch">
                                  mañana/mediodia/noche
                                </option>
                                <option value="manmed">mañana/mediodia</option>
                                <option value="mannoch">mañana/noche</option>
                                <option value="mednochs">mediodia/noche</option>
                                <option value="tarnoch">tarde/noche</option>
                                <option value="man">mañana</option>
                                <option value="med">mediodia</option>
                                <option value="noch">noche</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="field">
                          <label htmlFor="frechabitual">
                            Frecuencia habitual
                          </label>
                          <div className="control">
                            <div className="select">
                              <select
                                className="select"
                                name="frechabitual"
                                value={form.frechabitual}
                                onChange={(event) =>
                                  handleDatconsSustRepChange(event, index)
                                }
                              >
                                <option disabled value="">
                                  -- Selecciona una opción --
                                </option>
                                <option value="diario">diario</option>
                                <option value="unotressemana">
                                  1-3 semana
                                </option>
                                <option value="cuatroseissemana">
                                  4-6 semana
                                </option>
                                <option value="quincenal">quincenal</option>
                                <option value="mensual">mensual</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="field">
                          <label htmlFor="viaadministracion">
                            Vía de administración
                          </label>
                          <div className="control">
                            <div className="select">
                              <select
                                className="select"
                                name="viaadministracion"
                                value={form.viaadministracion}
                                onChange={(event) =>
                                  handleDatconsSustRepChange(event, index)
                                }
                              >
                                <option disabled value="">
                                  -- Selecciona una opción --
                                </option>
                                <option value="oral">oral</option>
                                <option value="nasal">nasal</option>
                                <option value="inhalada">inhalada</option>
                                <option value="intravenosa">intravenosa</option>
                                <option value="fumada">fumada</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="field">
                          <label htmlFor="edadinicial">Edad inicio</label>
                          <div className="control">
                            <input
                              className="input"
                              name="edadinicial"
                              type="number"
                              value={form.edadinicial}
                              onChange={(event) =>
                                handleDatconsSustRepChange(event, index)
                              }
                            />
                          </div>
                        </div>
                        <div className="field">
                          <label htmlFor="edadabuso">Edad abuso</label>
                          <div className="control">
                            <input
                              className="input"
                              name="edadabuso"
                              type="number"
                              value={form.edadabuso}
                              onChange={(event) =>
                                handleDatconsSustRepChange(event, index)
                              }
                            />
                          </div>
                        </div>
                        <div className="field">
                          <label htmlFor="mesesconsumact">
                            Meses consumo actual
                          </label>
                          <div className="control">
                            <input
                              className="input"
                              name="mesesconsumact"
                              type="number"
                              value={form.mesesconsumact}
                              onChange={(event) =>
                                handleDatconsSustRepChange(event, index)
                              }
                            />
                          </div>
                        </div>
                        <div className="field">
                          <label htmlFor="nivelimportancia">
                            Nivel de importancia
                          </label>
                          <div className="control">
                            <div className="select">
                              <select
                                className="select"
                                name="nivelimportancia"
                                value={form.nivelimportancia || ""}
                                onChange={(event) =>
                                  handleDatconsSustRepChange(event, index)
                                }
                              >
                                <option disabled value="">
                                  -- Selecciona una opción --
                                </option>
                                <option value="principal">Principal</option>
                                <option value="secundaria">Secundaria</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                      <button
                        className="button btn-remove is-danger is-light"
                        onClick={(event) => removeFields(event, index)}
                      >
                        Eliminar sustancia
                      </button>
                    </div>
                  );
                })}
                <button
                  className="button btn-add is-success is-light"
                  onClick={addDatconsSustRep}
                >
                  Añadir otra sustancia
                </button>

                {/* aqui termina el campo repetido */}
              </div>
              <div className="field">
                <label className="" htmlFor="datconsObs">
                  Observaciones
                </label>
                <div className="control">
                  <textarea
                    className="textarea"
                    name="datconsObs"
                    id="datconsObs"
                    value={datconsObs}
                    onChange={(e) => setDatconsObs(e.target.value)}
                  ></textarea>
                </div>
              </div>
            </fieldset>
          </form>
        )}
      </div>
      {!errorMessage && (
        <div id="actions">
          {(diffDate <= 72 || props.userRole.includes("administrador")) && (
            <button
              className="button is-link"
              id="saveButton"
              form="formUpdatelement"
              type="submit"
              disabled={isCreatingButton}
            >
              {isCreatingButton ? <div className="spinner"></div> : "Guardar"}
            </button>
          )}
          <Link
            className="button is-link is-light"
            to={`../${tratamientoId}/antecedentes/datos-consumo/${datconsumo.id}`}
          >
            Cancelar
          </Link>
          {props.userRole.includes("administrador") && (
            <button
              className="button is-danger"
              id="deleteButton"
              onClick={deleteItem}
              disabled={isDeletingButton}
            >
              {isDeletingButton ? <div className="spinner"></div> : "Eliminar"}
            </button>
          )}
        </div>
      )}
    </>
  );
}
